import React from 'react';

import {Icon} from '@udemy/icons';
import {BlockListProps, BlockList} from '@udemy/react-core-components';

interface FeatureListProps {
    features: React.ReactNodeArray;
    padding?: BlockListProps['padding'];
}

export function FeatureList(props: FeatureListProps) {
    const {features, ...htmlProps} = props;
    return (
        <BlockList size="large" iconAlignment="left" {...htmlProps}>
            {features?.map((featureContent, index) => {
                return (
                    <BlockList.Item
                        icon={<Icon glyph="success-outline" label={false} color="positive" />}
                        key={index}
                    >
                        {featureContent}
                    </BlockList.Item>
                );
            })}
        </BlockList>
    );
}
